import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { CreateBlockModal } from "../blocks/CreateBlockModal";

export function SaveAsBlockItem(props: { defaultTitle: string, saveBlock: (title: string) => void }) {
  const { defaultTitle, saveBlock } = props;
  const [showModal, setShowModal] = useState(false);

  const onClick = (title: string) => {
    saveBlock(title);
    setShowModal(false);
  };

  return (
    <>
      <Dropdown.Item
        aria-label={I18n.get('saveAsBlock')}
        onClick={() => setShowModal(true)}
      >
        {I18n.get('saveAsBlock')}
      </Dropdown.Item>
      {showModal && <CreateBlockModal setShowModal={setShowModal} saveBlock={onClick} defaultTitle={defaultTitle}/>}
    </>
  );
}
